/**
 * GH#1679 · 17.3 — a dónde lleva «Elegir plan» / «Ver planes», según el rol.
 * Cada ruta de acá está registrada en app/routing/routes/* con ESE rol (lo verifica
 * ruta-de-planes.test.ts). Antes vivía copiada en TrialExpiredBanner y mandaba a la
 * promotora a /promotora/configuracion/planes, que no existía (404).
 *
 * GH#2250 — la promotora (y el Combo, que es el mismo rol) ya tiene página de planes:
 * sus tres planes (Combo Desarrollo, Promotora, Constructora) tienen scope
 * PROJECT_DEVELOPER_ADMIN. Antes «cambiar plan» la mandaba a «Mi suscripción», o sea a
 * la misma página. Se suman las tablas de addons y de «Mi suscripción», que también
 * estaban fijas en las rutas de agencia.
 */
const POR_ROL: Record<string, string> = {
  AGENCY_ADMIN: '/agencia/configuracion/planes',
  BROKER_MANAGER_ADMIN: '/broker/configuracion/planes',
  CONDOMINIUM_ADMIN: '/condominium/configuracion/planes',
  PROJECT_DEVELOPER_ADMIN: '/promotora/configuracion/planes',
  SUPER_ADMIN: '/admin/subscription-policies?tab=plans',
};

/** Fallback igual al de antes: la de agencia. */
export const RUTA_PLANES_POR_DEFECTO = POR_ROL.AGENCY_ADMIN;

export function rutaDePlanes(role?: string | null): string {
  return (role && POR_ROL[role]) || RUTA_PLANES_POR_DEFECTO;
}

export const RUTAS_DE_PLANES_POR_ROL: Readonly<Record<string, string>> = POR_ROL;

/**
 * GH#2250 — la tienda de addons de cada rol que monta «Mi suscripción». La página es la
 * misma (AddonsStorePage); cambia la ruta, porque cada una está gateada por su rol.
 */
const ADDONS_POR_ROL: Record<string, string> = {
  AGENCY_ADMIN: '/agencia/configuracion/addons',
  CONDOMINIUM_ADMIN: '/condominium/configuracion/addons',
  PROJECT_DEVELOPER_ADMIN: '/promotora/configuracion/addons',
};

export function rutaDeAddons(role?: string | null): string {
  return (role && ADDONS_POR_ROL[role]) || ADDONS_POR_ROL.AGENCY_ADMIN;
}

export const RUTAS_DE_ADDONS_POR_ROL: Readonly<Record<string, string>> = ADDONS_POR_ROL;

/** GH#2250 — «Mi suscripción» de cada rol (para volver desde la tienda de addons). */
const MI_SUSCRIPCION_POR_ROL: Record<string, string> = {
  AGENCY_ADMIN: '/agencia/configuracion/mi-suscripcion',
  CONDOMINIUM_ADMIN: '/condominium/configuracion/mi-suscripcion',
  PROJECT_DEVELOPER_ADMIN: '/promotora/mi-suscripcion',
};

export function rutaDeMiSuscripcion(role?: string | null): string {
  return (role && MI_SUSCRIPCION_POR_ROL[role]) || MI_SUSCRIPCION_POR_ROL.AGENCY_ADMIN;
}

export const RUTAS_DE_MI_SUSCRIPCION_POR_ROL: Readonly<Record<string, string>> = MI_SUSCRIPCION_POR_ROL;

/** Agrega parámetros a una ruta que puede traer ya un `?` (la de SUPER_ADMIN lo trae). */
export function conParametros(ruta: string, params: URLSearchParams | string): string {
  const q = params.toString();
  if (!q) return ruta;
  return `${ruta}${ruta.includes('?') ? '&' : '?'}${q}`;
}
